import { loadView, loadComponent } from '@/helpers/asyncLoaders'

import store from '@/store/store'

import {
  VUEX_ROUTING_ENTER_DASHBOARD
} from '@/store/constants/routing/routingDashboard'

export default {
  path: '/ad-register/:pendingUser',
  // name: 'adRegister',
  component: loadView('app/Headless.vue'),
  children: [
    // {
    //   path: '',
    //   name: 'adRegister--default',
    //   redirect: { name: 'adRegister--its' }
    // },
    {
      path: '',
      name: 'adRegister--its',
      component: loadComponent('Dashboard/Dashboard_Its.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch(VUEX_ROUTING_ENTER_DASHBOARD, { to: to, from: from }).then(() => next())
      }
    }
  ],
  meta: {
    label: 'Dashboard'
  }
}
